import React from "react";

const LessonCheckIcon: React.FC<{ size?: string; style?: React.CSSProperties }> = ({ size = "1rem", style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M8.00098 1.33301C11.6827 1.33318 14.667 4.31822 14.667 8C14.667 11.6818 11.6827 14.6668 8.00098 14.667C4.31908 14.667 1.33398 11.6819 1.33398 8C1.33399 4.31811 4.31908 1.33301 8.00098 1.33301ZM11.707 5.29297C11.3409 4.92685 10.7619 4.90426 10.3691 5.22461L10.293 5.29297L7 8.58594L5.70703 7.29297L5.63086 7.22461C5.23809 6.90426 4.65908 6.92685 4.29297 7.29297C3.92685 7.65908 3.90426 8.23809 4.22461 8.63086L4.29297 8.70703L6.29297 10.707L6.36914 10.7754C6.76191 11.0957 7.34092 11.0731 7.70703 10.707L11.707 6.70703L11.7754 6.63086C12.0957 6.23809 12.0731 5.65908 11.707 5.29297Z"
      fill="#139E79"
    />
  </svg>
);

export default LessonCheckIcon;
